export const headers = {
	set: "~setcookie"
};

export type Method = "GET" | "POST";
